async function getGroundUpLoanQuoteData(
  answers,
  setTotalLoanLimit,
  setPriceLoanLimit,
  setRehabLoanLimit,
  setTotalLoanLeft,
  setPriceLoanLeft,
  setRehabLoanLeft,
  setRehabLoanLeftDisplay,
  setBridgePurchaseComponent,
  setBridgeRehabComponent
) {
  const targetUrl = `${process.env.CMS_URL}/loans/getgrounduploanterms`;

  const loanQuoteResp = await fetch(targetUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    //make sure to serialize your JSON body
    body: JSON.stringify(answers),
  });

  const respData = await loanQuoteResp.json();

  if (respData.error) {
    // setLoanQuoteData({});
  } else {
    // setLoanQuoteData(respData.response);
    // initial state for Bridge Loan Amount question
    setTotalLoanLimit(respData.response.totalLoanLimit);
    setPriceLoanLimit(respData.response.priceLoanLimit);
    setRehabLoanLimit(respData.response.rehabLoanLimit);
    setTotalLoanLeft(respData.response.totalLoanLimit);
    setPriceLoanLeft(respData.response.priceLoanLimit);
    setRehabLoanLeft(respData.response.rehabLoanLimit);
    setRehabLoanLeftDisplay(respData.response.rehabLoanLimit);
    setBridgePurchaseComponent(respData.response.priceLoanLimit);
    setBridgeRehabComponent(respData.response.rehabLoanLimit);
  }
}

export default getGroundUpLoanQuoteData;
